import type { ResultEntry } from '@schibsted-nmp/search-frontend-clients/quest';
import React from 'react';
import { useSearchData } from '../data/SearchData';
import { trackAdClick, trackAdInscreen } from './trackResults';

export function useAdTracking() {
    const { searchData } = useSearchData();

    const memoizedTrackAdClick = React.useCallback(
        (ad: ResultEntry, position: number) => {
            if (searchData) {
                const { metadata } = searchData;
                metadata.tracking &&
                    trackAdClick(
                        ad,
                        position,
                        metadata.tracking,
                        metadata.vertical,
                    );
            }
        },
        [searchData],
    );

    const memoizedTrackAdInscreen = React.useCallback(
        (ad: ResultEntry, position: number) => {
            if (searchData) {
                const { metadata } = searchData;
                metadata.tracking &&
                    trackAdInscreen(ad, position, metadata.tracking);
            }
        },
        [searchData],
    );

    return {
        trackAdClick: memoizedTrackAdClick,
        trackAdInscreen: memoizedTrackAdInscreen,
    };
}
